import React from 'react';
import ModelProperties from './ModelProperties';
import SummaryStatsMarginals from './SummaryStatsMarginals';
import ObservationEntryNumeric from './ObservationEntryNumeric';
import ObservationEntrySoftEvidence from './ObservationEntrySoftEvidence';
import ObservationEntryNodeVariables from './ObservationEntryNodeVariables';
import NodeVariablesView from './NodeVariablesView';
import NodeProbabilityTableView from './NodeProbabilityTableView';

export default () => (
  <>
    <ObservationEntrySoftEvidence />
    <ObservationEntryNumeric />
    <ObservationEntryNodeVariables />
    <ModelProperties />
    <SummaryStatsMarginals />
    <NodeVariablesView />
    <NodeProbabilityTableView />
  </>
);
